<template>
  <div class="bg">
    <div class="contents">
      <div class="top"><input @click="back" type="button" class="back"> {{carNumber}} 차량 ({{carItems.length}}대)</div>
      <div v-for="(item, index) in carItems" class="list" :key="index">
        <div><img v-bind:src="item.imageUrl" alt="차량 이미지" /></div>
        <p class="mt5">촬영시각 : {{item.detectionTime}}</p>
        <p>주차장 : {{item.site.siteName}}</p>
        <ul>
          <li>주차층 <span>{{item.location.floorName}}</span></li>
          <li>{{displayText}} <span>{{item.location.blockName}}</span></li>
        </ul>
        <div v-if="showMap"><img v-bind:src="item.thumbnailMap" alt="축소 지도" /></div>
        <div v-if="showMap" @click="moreDetail(item)" class="click">지도 자세히 보기 &gt;</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data() {
    return {
      carItems: [],
      carNumber: '',
      displayText: '',
      showMap: false,
    };
  },
  props: ['api'],
  created() {
    this.showMap = this.$route.query.map;
    this.carNumber = this.$store.getters.carNumber ? this.$store.getters.carNumber : sessionStorage.getItem('carNumber');
    this.carItems = !this._.isEmpty(this.$store.getters.carItems) ? this.$store.getters.carItems : JSON.parse(sessionStorage.getItem('carItems'));
    this.displayText = localStorage.getItem('displayText');
    if (!this._.isEmpty(this.carItems)) {
      if (this.showMap) this.init();
    } else {
      this.emptyItem();
    }
  },
  methods: {
    init() {
      this.carItems.forEach(e => {
        this.$http({
          method: 'post',
          url: this.api.cropMapUrl,
          responseType: 'blob',
          data: {
            siteId: e.site.siteId,
            mapName: e.location.position.mapImg,
            carNumber: e.carNumber,
            width: 400,
            height: 200,
            x: e.location.position.xy[0],
            y: e.location.position.xy[1],
            resolution: e.location.position.resolution,
            size: e.location.position.size,
            block: e.location.blockName,
          }
        })
        .then((response) => {
          e.thumbnailMap = URL.createObjectURL(new Blob([response.data], {type: 'image/png'}));
        });
      });
    },
    moreDetail(item) {
      sessionStorage.setItem('chosenItem', JSON.stringify(item));
      this.$store.commit({
        type: 'addChosenItem',
        chosenItem: item
      });
      this.$router.push('/detailMap');
    },
    back() {
      this.$router.push('/search');
    },
    emptyItem() {
      this.$router.push('/empty');
    }
  },
};
</script>

<style scoped>
  img {width:100%; display: block;}
</style>